const en_master_profile = {
    "": "profile",
    add: "add profile",
    edit: "edit profile",

    form: {

    },

    error: {
        name: "Profile name cannot be empty.",
        menu_list: "At least 1 menu access is required.",
        menu_list_min: "At least 1 account item is required to create a menu.",
        create: "Failed to create profile.",
        delete: "Failed to delete profile.",
        edit: "Failed to update profile.",
    },

    success: {
        create: "Profile created successfully.",
        delete: "Profile deleted successfully.",
        edit: "Profile updated successfully.",
    },
}

export default en_master_profile;